import React from "react";

import "./Loading.scss";

export default ({ size, marginAuto }) => {
  return <div style={{ fontSize: size + "px" }} className={`loader ${marginAuto ? "marginAuto" : ""}`} />;
};
